import Answer from '../vue/Answer.vue'
import Container from '../vue/Container.vue'
import EmailSignup from '../vue/EmailSignup.vue'
import Expert from '../vue/Expert.vue'
import FeaturedExpert from '../vue/FeaturedExpert.vue'
import Progress from '../vue/Progress.vue'
import Question from '../vue/Question.vue'
import RequestButton from '../vue/RequestButton.vue'
import Score from '../vue/Score.vue'
import Splash from '../vue/Splash.vue'
import Submitted from '../vue/Submitted.vue'
import ExpertMask from '../vue/ExpertMask'
import { createApp } from 'vue'

const main = async () => {
	const vm = createApp(Container, window.matchmakerData)
	vm.component('Answer', Answer)
	vm.component('Container', Container)
	vm.component('EmailSignup', EmailSignup)
	vm.component('Expert', Expert)
	vm.component('ExpertMask', ExpertMask)
	vm.component('FeaturedExpert', FeaturedExpert)
	vm.component('Progress', Progress)
	vm.component('Question', Question)
	vm.component('RequestButton', RequestButton)
	vm.component('Score', Score)
	vm.component('Splash', Splash)
	vm.component('Submitted', Submitted)
	vm.mount('#app')

	return vm
}

// Execute async function
main()

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (module.hot) {
	module.hot.accept()
}
